import axiosTuri from "../../axiosTuri";

// Create Reserve Tour
export const reserve = async (data) => {
  const res = await axiosTuri.post(`add-reservation`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store passport Photos API
export const storePassportPhotos = async (data) => {
  const res = await axiosTuri.post(`add-passports`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store passport Photos API
export const storeAirticketsPhotos = async (data) => {
  const res = await axiosTuri.post(`add-airtickets`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete passport or airticket Photo
export const deletePassportOrAirTicket = async (data) => {
  const res = await axiosTuri.post(`delete-photo`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store passport Photos API
export const getAllReservations = async (id) => {
  const res = await axiosTuri.get(`get-all-reservations/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Drivers
export const getAllDrivers = async (destination_id) => {
  const res = await axiosTuri.get(`get-all-drivers/${destination_id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Reserve Driver
export const reserveDriver = async (data) => {
  const res = await axiosTuri.post(`reserve-driver/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Send Email
export const sendEmail = async (data) => {
  const res = await axiosTuri.post(`send-email`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Cancel Email
export const cancelEmail = async (data) => {
  const res = await axiosTuri.post(`cancel-email`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store Confirmation Photos API
export const storeConfirmationPhotos = async (data) => {
  const res = await axiosTuri.post(`add-confirmations`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store Invoice Photos API
export const storeInvoicePhotos = async (data) => {
  const res = await axiosTuri.post(`add-invoices`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Store Payment Photos API
export const storePaymentPhotos = async (data) => {
  const res = await axiosTuri.post(`add-payments`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Hotel Docoments
export const deleteHotelDocoments = async (data) => {
  const res = await axiosTuri.post(`delete-hotel-docoment`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// set invoice price
export const setInvoicePrice = async (data) => {
  const res = await axiosTuri.post(`set-invoice-price`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// set payment price
export const setPaymentPrice = async (data) => {
  const res = await axiosTuri.post(`set-payment-price`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Reserve Tourguide
export const reserveTourguide = async (data) => {
  const res = await axiosTuri.post(`reserve-tourguide/${data.id}`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};
